import { useEffect, useState } from "react";
import App from "./App";
import { useStateContext } from "@xkit-yx/im-kit-ui";
import general, { redux } from "./general";
import useActiveState from "./lib/useActiveState";
import RedEnvelopeAlert from "./view/game/im/chat/redEnvelope/RedEnvelopeAlert";
import Dialog from "./lib/Dialog";

export default function IMAppContainer() {
  const { store, nim } = useStateContext();
  const [allUnreadCount, setAllUnreadCount] = useState(0);
  const [logined, setLogined] = useActiveState("im-logined");
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [pushContent, setPushContent] = useState();

  useEffect(() => {
    redux.dispatch({
      type: "unread",
      data: {
        unread: allUnreadCount,
      },
    });
  }, [allUnreadCount]);

  const handleUnread = () => {
    setAllUnreadCount(store.uiStore.sessionUnread);
  };

  const filterUnreadCount = () => {
    setTimeout(() => {
      handleUnread();
    }, 1000);
  };
  // 静默 @xkit-yx/im-store 内部的高频日志（每条消息都触发，对开发无价值）：
  // getTeamSessionList / getP2pSessionList / subscribeLoginStateActive / getTeamActive
  // 仅过滤 im-store 前缀 + 指定函数名，错误日志 (console.error) 保持不变。
  useEffect(() => {
    const _origLog = console.log;
    const NOISY = /^(getTeamSessionList|getP2pSessionList|subscribeLoginStateActive|getTeamActive)/;
    console.log = (...args) => {
      const prefix = String(args[0] ?? '');
      const funcName = String(args[1] ?? '');
      if (prefix.includes('@xkit-yx/im-store') && NOISY.test(funcName)) return;
      _origLog(...args);
    };
    return () => { console.log = _origLog; };
  }, []);

  // 为 getTeamActive 添加 negative cache：
  // error 803（群不存在）的团队 ID 会被记住，后续直接抛出而不重复发起网络请求。
  // getTeamSessionList 使用 Promise.allSettled，拒绝的 promise 会被安全过滤掉。
  useEffect(() => {
    if (!store?.teamStore) return;
    const teamStore = store.teamStore;
    const _original = teamStore.getTeamActive.bind(teamStore);
    const failedIds = new Set();

    teamStore.getTeamActive = async (teamId) => {
      // 负缓存：曾经 error 803 的群直接拒绝，不打 log、不发请求
      if (failedIds.has(teamId)) {
        throw Object.assign(new Error('Team not found (cached)'), { code: 803 });
      }
      // 正缓存：已存在的群直接返回，跳过库内部的 logger.log（它在缓存检查之前打印）
      const hit = teamStore.teams.get(teamId);
      if (hit) return hit;
      // 仅对首次未缓存的群走原始流程
      try {
        return await _original(teamId);
      } catch (e) {
        if (e?.code === 803) failedIds.add(teamId);
        throw e;
      }
    };

    return () => {
      teamStore.getTeamActive = _original;
    };
  }, [store]);

  // 拦截 getP2pSessionList：p2p 会话列表结果为空时直接返回缓存，跳过日志和内部处理
  useEffect(() => {
    if (!store?.uiStore) return;
    const uiStore = store.uiStore;
    const _origP2p = uiStore.getP2pSessionList.bind(uiStore);
    let _lastP2pResult = [];

    uiStore.getP2pSessionList = async (params) => {
      // 若 p2p 会话列表为空（大多数情况）直接返回缓存结果，避免日志噪声
      const p2pSessions = (params?.sessions || []).filter(s => s.scene === 'p2p');
      if (!p2pSessions.length) return _lastP2pResult;
      const result = await _origP2p(params);
      _lastP2pResult = result;
      return result;
    };

    return () => {
      uiStore.getP2pSessionList = _origP2p;
    };
  }, [store]);

  // 拦截 subscribeLoginStateActive：accounts 为空时直接返回，跳过库内部日志
  useEffect(() => {
    if (!store?.eventStore) return;
    const eventStore = store.eventStore;
    const _origSubscribe = eventStore.subscribeLoginStateActive.bind(eventStore);

    eventStore.subscribeLoginStateActive = async (accounts) => {
      if (!accounts?.length) return;
      return _origSubscribe(accounts);
    };

    return () => {
      eventStore.subscribeLoginStateActive = _origSubscribe;
    };
  }, [store]);

  useEffect(() => {
    var nimInstance = nim.getNIM();
    nimInstance.options.oncustomsysmsg = (msg) => {
      console.log("test--------customsysmsg", msg);
      const content = JSON.parse(msg.content);
      console.log("test--------content", content);
      const type = content.type;

      // 批量处理布尔转换
      const boolKeys = ['is_can_snatched', 'is_exists', 'is_pop_bullet', 'is_preview_red'];
      const convertedData = { ...content.data };

      boolKeys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(convertedData, key)) {
          // 处理 '1'/'0', 1/0, 'true'/'false', true/false
          const val = convertedData[key];
          convertedData[key] = (val === '1' || val === 1 || val === 'true' || val === true);
        }
      });
      
      setPushContent({ ...convertedData, type: content.type });
      if (type == "join_cluster_redenvelope") {
        // 社区
        setIndex((e) => e + 1);
      } else if (type == "cluster_task_accomplish") {
        // 群聊
        updateChat(content)
      }
    };

    nim.on("msg", (msg) => {
      setTimeout(() => {
        handleUnread();
      }, 100);
    });
    nim.on("syncdone", (res) => {
      setLogined(true);
      localStorage.setItem("yx_login", true);
      filterUnreadCount();
    });
    nim.on("logined", () => {
      localStorage.setItem("yx_login", true);
      setLogined(true);
    });
  }, []);

  useEffect(() => {
    if (index > 0) {
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    }
  }, [index]);

  const updateChat = (content) =>{
    redux.dispatch({
      type: "refreshActiveRedEnvelope",
      data: {
        refreshRedEnvelopeData: content.data,
      },
    });
  }

  const handleAction = (info) => {
    console.log("info----", info);

    if (info.type == "join_cluster_redenvelope") {
      Dialog.loading();
      general.axios
        .post("/base/yunxin/joinTeams", {
          topic_id: info.maiyou_gameid,
        })
        .finally(() => {
          Dialog.close();
        })
        .then((res) => {
          const { data, status } = res.data;
          if (status.succeed) {
            const { tid } = data.info;
            general.history.push(`/chat?tid=${tid}`);
            // if (localStorage.getItem('yx_login')){
            //   general.history.push(`/chat?tid=${tid}`)
            // }else{
            //   PubSub.publish('loginSubscribe',true)
            //   setTimeout(()=>{
            //     general.history.push(`/chat?tid=${tid}`)
            //   },2000)
            // }
          } else {
            Dialog.error(status.error_desc);
          }
        });
    }
  };

  return (
    <div>
      <App />
      {index > 0 && (
        <RedEnvelopeAlert
          visible={visible}
          type={"join_cluster_redenvelope"}
          getContainer={document.getElementsByClassName("screen-chat-index")[0]}
          attach={pushContent}
          handleAction={handleAction}
        ></RedEnvelopeAlert>
      )}
    </div>
  );
}
